<template>
  <component
    :is="tag"
    class="col"
    :class="`${cols ? `col-${cols}` : ''} ${offset ? `offset-${offset}` : ''}`"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BCol',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    cols: {
      type: [Number, String],
      default: null
    },
    offset: {
      type: [Number, String],
      default: null
    }
  }
}
</script>
